import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { Account } from 'src/app/shared/models/user-management.model';
import { environment } from 'src/environments/environment';

interface ResUpdateStatus {
  success: boolean;
  message: string;
  result: {
    UPDATESTATUSTIME: Date;
    USER_ID: string;
    ROLE: string;
  }
}

interface ResAccountTable {
  success: boolean;
  message: string;
  result: Account[];
}

interface resLogsHistory {
  success: boolean;
  message: string;
  result: [{
    date: string,
    description: string,
  }];
}

@Injectable({
  providedIn: 'root'
})
export class UserManagementService {
  token: string;

  constructor(private http: HttpClient, private authService: AuthService) {
    this.authService.token.subscribe(res => this.token = res ? res : environment.KEY);
  }

  getTable(name) {
    const headers = new HttpHeaders({
      Authorization: this.token
    })

    return this.http.get<ResAccountTable>(environment.URL + '/manage_admin/getUserByCategory?type=' + name, { headers: headers })
  }

  updateStatusAccount(body) {
    const headers = new HttpHeaders({
      Authorization: this.token
    })
    return this.http.post<ResUpdateStatus>(environment.URL + '/manage_admin/updateStatusAccountByUser', body, { headers: headers });
  }

  createAccountAdmin(userData) {
    const headers = new HttpHeaders({
      Authorization: this.token
    })

    const body = {
      'EMAIL': userData.email,
      'USERNAME': userData.username,
    }
    return this.http.post<any>(environment.URL + '/authen/CreateAccountAdmin', body, { headers: headers });
  }

  createAccountTeacher(userData) {
    const headers = new HttpHeaders({
      Authorization: this.token
    })

    // console.log(userData);


    const body = {
      'EMAIL': userData.email,
      'USERNAME': userData.username,
      'EXPERTIES': userData.experties ? JSON.parse(userData.experties) : []
    }
    return this.http.post<any>(environment.URL + '/authen/CreateAccountTeacher', body, { headers: headers });
  }

  createAccountPsychologistn(userData) {
    const headers = new HttpHeaders({
      Authorization: this.token
    })

    // console.log(userData);


    const body = {
      'EMAIL': userData.email,
      'USERNAME': userData.username,
      'EXPERTIES': userData.experties ? JSON.parse(userData.experties) : []
    }
    return this.http.post<any>(environment.URL + '/authen/CreateAccountPsychologist', body, { headers: headers });
  }


  updateProfileUser(body) {
    const headers = new HttpHeaders({
      Authorization: this.token
    })
    // console.log(body);
    return this.http.post(environment.URL + '/manage_admin/updateProfileUserById', body, { headers: headers });
  }

  updateProfileTeaOrPsy(body) {
    const headers = new HttpHeaders({
      Authorization: this.token
    })
    // console.log(body);
    return this.http.post(environment.URL + '/manage_admin/updateProfileTeaOrPhyById', body, { headers: headers });
  }

  updateProfileAdmin(body) {
    const headers = new HttpHeaders({
      Authorization: this.token
    })
    // console.log(body);
    return this.http.post(environment.URL + '/manage_admin/updateProfileAdminById', body, { headers: headers });

  }

  getLogsHistoryByUser(body) {
    const headers = new HttpHeaders({
      Authorization: this.token
    })

    return this.http.post<resLogsHistory>(environment.URL + '/manage_history/getLogsHistoryByUser', body, { headers: headers });

  }
}
